import { ERROR_CODES } from '../utils/errorMessages';

const handleApiError = (error, navigate) => {
  if (error.errorCode) {
    const { errorCode, statusCode, status } = error;

    const isInvalidAccess = errorCode === ERROR_CODES.INVALID_ACCESS_TOKEN;

    if (isInvalidAccess) {
      navigate('/login');
    }
  } else {
    console.error('Network error or no response received');
  }

  throw error;
};

export default handleApiError;
